const LOCALSTACK_PORT = 4566;
const CHECKSUM_PARAMS = ["x-amz-checksum-crc32", "x-amz-sdk-checksum-algorithm"];

export function rewriteToLocalStack(presignedUrl: string): string {
  try {
    const parsed = new URL(presignedUrl);

    const isLocalStack = parsed.port === String(LOCALSTACK_PORT);
    const isAwsVirtualHosted = parsed.hostname.match(/^(.+?)\.s3(?:[.-][^.]+)*\.amazonaws\.com$/);

    if (isAwsVirtualHosted) {
      const bucket = isAwsVirtualHosted[1];
      parsed.hostname = "localhost";
      parsed.port = String(LOCALSTACK_PORT);
      parsed.protocol = "http:";
      parsed.pathname = `/${bucket}${parsed.pathname}`;
    } else if (!isLocalStack) {
      return presignedUrl;
    }

    CHECKSUM_PARAMS.forEach((p) => parsed.searchParams.delete(p));
    return parsed.toString();
  } catch {
    return presignedUrl;
  }
}

export function toLocalStackUrl(presignedUrl: string): string {
  if (!import.meta.env.DEV) return presignedUrl;
  return rewriteToLocalStack(presignedUrl);
}
